import cmp from '../../lib/cmp';
import on from '../../lib/dom/on';
import { removeClass } from '../../lib/dom/className';
import trackEditorNotesView from '../../lib/track-event/editor-notes-view';
import template from './sm-landing-appstore-app-1-editor-notes.template.js';
import './sm-landing-appstore-app-1-editor-notes.less';



export default cmp(null, template, (element) => {
  const offClick = on(element, 'click', () => {
    offClick();
    removeClass(element, 'sm-landing-appstore-app-1-editor-notes--show-more');
    trackEditorNotesView();
  });

  return () => {
    offClick();
  };
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-editor-notes/sm-landing-appstore-app-1-editor-notes.js